import { formatToE164, renderConditionalProp } from "utility";
import classes from "./PayByText.module.scss";
import { UseInput } from "hooks";
import { useEffect } from "react";

interface PhoneSectionProps {
  phoneNumber: UseInput;
  t: (key: string, options?: any) => string;
  isEnabled: boolean;
}

export const PhoneSection = ({
  phoneNumber,
  t,
  isEnabled,
}: PhoneSectionProps) => {
  const e164Pattern = "^\\+1[2-9][0-9]{9}$";

  const formatValidatePhoneNumber = (value: string) => {
    const formatted = formatToE164(value);

    // Manually update the field's value and validity
    const inputElement = phoneNumber.ref.current;
    if (inputElement) {
      inputElement.value = formatted;
      inputElement.setCustomValidity("");

      // Check if the field is valid
      if (!new RegExp(e164Pattern).test(formatted)) {
        inputElement.setCustomValidity(t("common:phone_validation"));
      } else {
        inputElement.setCustomValidity("");
      }

      inputElement.reportValidity();
    }

    return formatted;
  };

  const handlePhoneNumberInput = (e: any) => {
    const formatted = formatValidatePhoneNumber(e.target.value);

    phoneNumber.valueChangeHandler({
      ...e,
      target: {
        ...e.target,
        value: formatted,
      },
    });
  };

  const handlePhoneNumberBlur = (e: any) => {
    const formatted = formatValidatePhoneNumber(e.target.value);

    phoneNumber.valueChangeHandler({
      ...e,
      target: {
        ...e.target,
        value: formatted,
      },
    });
  };

  // Add custom validation logic
  const applyCustomValidation = () => {
    const inputElement = phoneNumber.ref.current;
    if (inputElement) {
      inputElement.validityTransform = (
        value: string,
        nativeValidity: ValidityState
      ): Partial<ValidityState> => {
        if (!nativeValidity.valid) {
          inputElement.validationMessage = t("common:phone_validation");
          return { valid: false };
        } else if (!new RegExp(e164Pattern).test(value)) {
          inputElement.validationMessage = t("common:phone_validation");
          return { valid: false };
        }
        return { valid: true };
      };
    }
  };

  // Apply custom validation on mount
  useEffect(() => {
    applyCustomValidation();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.SectionWrapper}>
      <p className={classes.Heading}>{t("payment:paybytext_enroll")}</p>
      <span className={classes.DialogLine}>
        {t("payment:paybytext_enroll_description")}
      </span>
      <ft-textfield
        outlined
        ref={phoneNumber.ref}
        id="phoneNumber"
        label={t("account_next:cell_phone")}
        value={phoneNumber.value}
        validationMessage={t("common:phone_validation")}
        pattern={e164Pattern}
        onInput={handlePhoneNumberInput}
        onBlur={handlePhoneNumberBlur}
        required
        {...renderConditionalProp(!isEnabled, "disabled")}
      />
    </div>
  );
};
